import * as componentsTypes from '../types/Components';
import * as apiCalls from '../api/ApiCalls';
import * as errorActions from './Error';

export function GetComplaintPositionComponents() {
    return async (dispatch) => {
        dispatch(getComplaintPositionComponentsRequest());
        try {
            dispatch(errorActions.clearError());
            const response = await apiCalls.GetComplaintPositionComponents();
            const result = await response.json();
            if(response.status===200) {
                return dispatch(getComplaintPositionComponentsSuccess(result));
            }
            else{
                return dispatch(errorActions.throwNewError("Błąd pobierania danych",result.exceptionMessage));
            }
            
        } catch (error) {
            dispatch(errorActions.throwNewError("Błąd pobierania danych",error.message));
        }
    };
} 

export function getComplaintPositionComponentsRequest() {
    return {
        type: componentsTypes.GET_COMPONENTS_REQUEST
    };
}

export function getComplaintPositionComponentsSuccess(components) {
    return {
        type: componentsTypes.GET_COMPONENTS_SUCCESS,
        payload: components
    };
}

export function getComplaintPositionComponentsFailure(error) {
    return {
        type: componentsTypes.GET_COMPONENTS_FAILURE,
        payload: error
    };
}


// WEBPACK FOOTER //
// ./src/actions/Components.js